import { TdsTooltip } from '@trv-tds/react'
import styled from 'styled-components'

//need to determine widths of different devices
const Content = styled.div`
  max-width: 250px;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
`

type TdsFileNameTooltipProps = {
  fileName: string
}

//confirm browser compatibility with word-wrap set
const TdsFileNameTooltip = ({ fileName }: TdsFileNameTooltipProps) => {
  return (
    <TdsTooltip role='tooltip' id={fileName} aria-label={'View entire file name'}>
      <Content>
        {fileName}
      </Content>
    </TdsTooltip>
  )
}

export { TdsFileNameTooltip }
